import { BOARD_TEXT_FONT } from "./textSession";
import type { Style } from "@bezpart-board/shared";

export type StickyToolSettings = {
  backgroundColor: string;
  color: string;
};

const STORAGE_KEY = "wb-sticky-settings";
const EVENT_NAME = "wb-sticky-settings";

const DEFAULT_SETTINGS: StickyToolSettings = {
  backgroundColor: "#fef08a",
  color: "#1a1a2e",
};

function loadSettings(): StickyToolSettings {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    const p = JSON.parse(raw) as Partial<StickyToolSettings>;
    return {
      backgroundColor:
        typeof p.backgroundColor === "string"
          ? p.backgroundColor
          : DEFAULT_SETTINGS.backgroundColor,
      color: typeof p.color === "string" ? p.color : DEFAULT_SETTINGS.color,
    };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

let settings: StickyToolSettings = loadSettings();

export function stickySettingsEventName(): string {
  return EVENT_NAME;
}

export function getStickySettings(): StickyToolSettings {
  return settings;
}

export function setStickySettings(partial: Partial<StickyToolSettings>): void {
  settings = { ...settings, ...partial };
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch {
    /* ignore */
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(EVENT_NAME));
  }
}

export function stickyStyleFields(s: StickyToolSettings): Style {
  return {
    backgroundColor: s.backgroundColor,
    color: s.color,
    fontSize: 15,
    fontFamily: BOARD_TEXT_FONT,
    textAlign: "left",
    lineHeight: 1.35,
  };
}

/** Палитра фона стикера (инструмент + панель выделения). */
export const STICKY_BG_PRESETS = [
  "#fef08a",
  "#fef9c3",
  "#bbf7d0",
  "#bfdbfe",
  "#fbcfe8",
  "#e9d5ff",
  "#ffffff",
] as const;

export const STICKY_SIZE = { w: 200, h: 200 } as const;
